import { configureStore } from "@reduxjs/toolkit";
import mainLayoutReducer from "../layouts/slice/mainLayoutSlice";

export const store = configureStore({
    reducer:{
        mainLayout: mainLayoutReducer
    }
})